<template>
  <div class="checkbox-wrapper" v-on:click="onClick">
    <input type="checkbox" :required="required" v-model="internValue" >
    <div class="checkbox">
      <i id="checkbox-icon" class="fas fa-check" v-bind:class="value ? 'enabled' :'disabled'"></i>
    </div>

    <slot>
      <div class="checkbox-label" v-html="checkboxText"/>
    </slot>

  </div>
</template>

<script>
import {isDefined} from "../../utils";

export default {
  name: "CustomCheckBox",
  props: {
    value: {
      required: true
    },
    checkboxText: {
      type: String,
      required: false
    },
    required: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      internValue: undefined
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!isDefined(newVal)) {
          this.$emit('update:value', false);
          this.internValue = false;
        }else {
          this.internValue = newVal;
        }
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('change', !this.internValue);
      this.$emit('update:value', !this.internValue);
    }
  }
}
</script>
